import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { stateFactories, actionsHandlers } from 'store/features/utils';
import * as actions from '../actions';

const stateFactory = stateFactories.createInitialMultipleFeatureStateFactory();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const toggleFavoriteEventReducer = createReducer<State, Actions>(initialState, {
  [actions.toggleFavoriteEvent.request.type]: actionsHandlers.handleMultipleFeatureRequest,
  [actions.toggleFavoriteEvent.success.type]: actionsHandlers.handleMultipleFeatureSuccess,
  [actions.toggleFavoriteEvent.failure.type]: actionsHandlers.handleMultipleFeatureFailure,
  [actions.toggleFavoriteEvent.reset.type]: actionsHandlers.handleMultipleFeatureReset,
});

export default toggleFavoriteEventReducer;
